import type { SupportMessage } from '@manaro/contracts'
import { dayLabel, splitLinks } from '@/features/support-chat/chat-format.ts'
import { cn } from '@/shared/lib/cn.ts'
import { formatTime } from '@/shared/lib/format.ts'

/** A finished conversation with the bot, read like a chat: the salon on the left, the bot on the right. */
export function ConversationView({ messages }: { messages: SupportMessage[] }) {
  return (
    <div className="mx-auto flex max-w-[760px] flex-col px-3 py-4 md:px-5">
      {messages.map((message, index) => {
        const fromUser = message.role === 'user'
        const day = message.createdAt ? dayLabel(message.createdAt) : null
        const previous = messages[index - 1]
        const newDay = day && (!previous?.createdAt || dayLabel(previous.createdAt) !== day)
        return (
          <div key={message.id} className="flex flex-col">
            {newDay && (
              <div className="my-3 self-center rounded-full bg-canvas/90 px-3 py-1 text-[12px] font-medium text-ink-muted">
                {day}
              </div>
            )}
            <div className={cn('mb-2.5 flex flex-col', fromUser ? 'items-start' : 'items-end')}>
              <div
                className={cn(
                  'max-w-[86%] rounded-[18px] px-3.5 pt-2 pb-1.5 text-[15px] leading-[1.45] whitespace-pre-wrap [overflow-wrap:anywhere] md:max-w-[75%]',
                  fromUser ? 'rounded-bl-[6px] border border-line-soft bg-surface' : 'rounded-br-[6px] bg-brand-tint',
                )}
              >
                {splitLinks(message.text).map((part, partIndex) =>
                  part.kind === 'link' ? (
                    <a
                      key={partIndex}
                      href={part.value}
                      target="_blank"
                      rel="noreferrer"
                      className="break-all text-brand-ink underline underline-offset-2"
                    >
                      {part.value}
                    </a>
                  ) : (
                    <span key={partIndex}>{part.value}</span>
                  ),
                )}
                {message.createdAt && (
                  <span className="tabular float-right mt-1.5 ml-3 text-[11px] leading-none text-ink-faint">
                    {formatTime(message.createdAt)}
                  </span>
                )}
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
